// @file Helper functions for surface comments
import { CommentAttachmentState, CommentDraftState } from '@@/enums'
import type { CommentDraft } from '@@/types/surface_comments'
import { uniqueId } from 'es-toolkit/compat'

const addCommentCidIfAbsent = (comment) => {
  if (comment.cid) return comment
  if (comment.id != null) return { ...comment, cid: `comment_${comment.id}` }
  return { ...comment, cid: uniqueId('comment_new_') }
}

// Creates a new comment draft with default attributes.
const newCommentDraft = (attributes: Partial<CommentDraft>): CommentDraft => {
  return addCommentCidIfAbsent({
    draftState: CommentDraftState.Writing,
    draftStartedAt: new Date().toISOString(),
    ...attributes,
  })
}

const isDraftEmpty = (draft: CommentDraft): boolean => {
  const trimmedHtmlBody = draft.html_body?.trim() ?? ''
  if (trimmedHtmlBody !== '') return false

  const attachment = draft.attachment ?? null
  if (attachment != null) return false

  const attachmentState = draft.attachmentState ?? CommentAttachmentState.IDLE
  if (attachmentState !== CommentAttachmentState.IDLE) return false

  const uploadingFile = draft.uploadingFile ?? null
  if (uploadingFile != null) return false

  const uploadingProgress = draft.uploadingProgress ?? 0
  if (uploadingProgress !== 0) return false

  const uploadJob = draft.uploadJob ?? null
  if (uploadJob != null) return false

  return true
}

const isDraftForNewComment = (draft: CommentDraft): boolean => {
  return draft.id == null
}

export { addCommentCidIfAbsent, isDraftEmpty, isDraftForNewComment, newCommentDraft }
